import React from "react"

import { Form, Formik } from "formik"
import { NotificationManager } from "react-notifications"
import * as Yup from "yup"

import { adminClient as client } from "src/urql-client"

import { gql, useMutation } from "hooks/urql"

import { handleFailure } from "components/Forms/Formik/hookComponents"
import ModalWithProvidedBody, { Footer } from "components/ModalWithProvidedBody"

import FormFields from "./FormFields"

import { ReferralType } from "."

const ValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name required"),
})

export type NewReferralProps = {
  referral: ReferralType
  closeModal: VoidFunction
}

const NewReferral: React.FC<NewReferralProps> = ({ referral, closeModal }) => {
  const [, runMutation]: any[] = useMutation(updateReferralMutation, client)

  if (!referral) return null

  const formState = {
    id: referral.id,
    userType: referral.userType,
    firstName: referral.firstName,
    lastName: referral.lastName,
    email: referral.email,
    phoneNumber: referral.phoneNumber,
    gradeId: referral.gradeId,
  }

  const handleSubmit = (values, actions) => {
    runMutation({ input: values })
      .then(
        result => {
          const { failures } = result.data.updateReferral
          if (failures.length > 0) {
            handleFailure(actions, failures)
          } else {
            closeModal()
            NotificationManager.success("Referral updated")
          }
        },
        () => handleFailure(actions)
      )
      .catch(() => handleFailure(actions))
  }

  return (
    <>
      <ModalWithProvidedBody
        hideTrigger
        modalTitle="Update Referral"
        isOpen={!!referral}
        closeModal={closeModal}
      >
        {({ closeModal }) => (
          <>
            <Formik
              initialValues={formState}
              onSubmit={handleSubmit}
              validationSchema={ValidationSchema}
            >
              <Form>
                <div className="modal-body">
                  <FormFields />
                </div>

                <Footer cancelAction={closeModal} />
              </Form>
            </Formik>
          </>
        )}
      </ModalWithProvidedBody>
    </>
  )
}

const updateReferralMutation = gql`
  mutation UpdateReferral($input: ReferralInputObject!) {
    updateReferral(input: $input) {
      failures {
        message
      }
    }
  }
`

export default NewReferral
